// Whether a value is shaped like an activation code: two runs of letters or
// digits joined by a hyphen, in either case. A Signage Stick shows its code in
// lower case and an older screen in capitals; the API client lower-cases the
// code before it claims, so both reach the API the same.
export const isActivationCode = (activationCode: string | null): boolean =>
  !!activationCode && /^[A-Za-z0-9]+-[A-Za-z0-9]+$/.test(activationCode);
